module.exports = {"653023100":"阿合奇镇","653023200":"库兰萨日克乡","653023201":"色帕巴依乡","653023202":"苏木塔什乡","653023203":"哈拉奇乡","653023204":"哈拉布拉克乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/653023.json
// module id = 3103
// module chunks = 0